interface EvalToolbarProps {
  totalImages: number;
  labeledCount: number;
  hasUnsavedChanges: boolean;
  isSaving: boolean;
  isLoadingMore: boolean;
  hasMore: boolean;
  hasStarted: boolean;
  isFiltersOpen: boolean;
  statusMessage: string | null;
  statusType: "ok" | "err" | null;
  onSave: () => void;
  onLoadMore: () => void;
  onNewEval: () => void;
}

const EvalToolbar: React.FC<EvalToolbarProps> = ({
  totalImages,
  labeledCount,
  hasUnsavedChanges,
  isSaving,
  isLoadingMore,
  hasMore,
  hasStarted,
  isFiltersOpen,
  statusMessage,
  statusType,
  onSave,
  onLoadMore,
  onNewEval
}) => {
  return (
    <div className="eval-toolbar">
      <button className="save-btn" onClick={onSave} disabled={isSaving || labeledCount === 0 || !hasUnsavedChanges}>
        {isSaving ? "Saving..." : "Save Results"}
      </button>
      <button className="more-btn" onClick={onLoadMore} disabled={isLoadingMore || !hasMore}>
        {isLoadingMore ? "Loading..." : "Load More"}
      </button>
      <button className="new-eval-btn" onClick={onNewEval} disabled={isFiltersOpen && !hasStarted} type="button">
        Filters
      </button>
      <span className="toolbar-counter">{labeledCount} evaluated</span>
      {hasStarted && <span className="toolbar-status">{totalImages} loaded</span>}
      {statusMessage && <span className={`toolbar-msg ${statusType || ""}`}>{statusMessage}</span>}
    </div>
  );
};

export default EvalToolbar;
